export const isMsk = (city: string) => {
  return city.toLowerCase() === 'москва'
}
